import { Injectable } from '@angular/core';
import { Router, Params, ActivatedRoute, Resolve } from '@angular/router';
import { Client } from './client.model';
import { ClientService } from './client.service';


@Injectable()
export class ClientListGuard implements Resolve<Client> {

  constructor(public router: Router, private clientService: ClientService) { }

  resolve() {
    return this.clientService.getClientList();
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/client/client-list.guard.ts